<template>
    <div>
        <div class="d-flex flex-column align-items-center mt-4">
            <!-- Iterate mainElements -->
            <div
                v-for="(mainElement,key,i) in app.currentConfiguration.mainElementParameters"
                class="d-flex flex-column"
                :class="[isDesktop ? 'mb-2 mt-2' : '',
                        isTablet ? 'mb-5 mt-3' : '',
                        isMobile2 ? 'mb-5 mt-3' : '',
                        isMobile ? 'mb-5 mt-3' : '']"
                :key="i"
            >
                <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between align-items-center pt-3">
                        <span>
                            <editParameterValueComponent
                                ref="editParameterValueComponent"
                                :parameter="mainElement['unidades']"
                                :value.sync="mainElement['unidades'].value"
                                :labelOverInput="isMobile ? true : false"
                                :style_inside_textbox="'width:' + input_width + 'px'"
                                @update:value="refreshParameters"
                            ></editParameterValueComponent>
                        </span>

                        <!-- @click.stop="cleanAllSelectors()" -->
                        <button
                            @click.stop="cleanSpecificSelectors(key)"
                            style="font-weight:lighter; border-radius: 50%; height:40px; width:40px"
                            class="btn btn-outline-secondary ml-2"
                        >
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </div>

                    <div
                        class="card-body d-flex flex-column justify-content-between align-items-center flex-sm-row"
                    >
                    <!-- ------------------- -->
                    <!--        imatge       -->
                    <!-- ------------------- -->
                        <!-- style="max-width:250px; max-height:250px; width: 100%; height:auto" -->
                        <img
                            :style="'height: ' + imgSize + 'px; width: ' + imgSize + 'px;'"
                            class="mb-1"
                            :src="mainElement['dimensiones'].value ?
                                 mainElement['dimensiones'].value.image :
                                 mainElement['dimensiones'].values[0].image"
                            :ref="'div_imgs_52' + key"
                        />
                    <!-- ------------------- -->

                        <div class="ml-3">
                            <editParameterValueComponent
                                ref="editParameterValueComponent"
                                :parameter="mainElement['dimensiones']"
                                :value.sync="mainElement['dimensiones'].value"
                                :labelOverInput="isMobile || isMobile2 || isTablet ? true : false"
                                :style_inside_dropdown="'width: ' + input_width + 'px'"
                                @update:value="refreshParameters"
                            ></editParameterValueComponent>
                        </div>
                    </div>

                    <!-- ------------- -->
                    <!-- REMOVE BUTTON -->
                    <!-- ------------- -->
                    <div class="d-flex flex-row align-items-center justify-content-center">
                        <button
                            v-show="showDeleteButton"
                            @click="removebandeja(key, key + '_loading_remove')"
                            class="btn btn-outline-dark btn_rounded btn_size"
                            style="z-index: 998; width: 42px"
                            :style="'position: absolute; top:' + topPositionRemoveButton + 'px' +
                                '; left: ' + leftPositionRemoveButton + 'px;'"
                        >
                            <i
                                v-if="buttonsLoading[key + '_loading_remove']"
                                class="fa fa-spinner fa-spin"
                            ></i>
                            <i v-else class="fas fa-minus fa-sm"></i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- ADD BUTTON -->
            <button
                @click="addElement('loading_add_button')"
                class="btn btn-outline-dark btn_rounded btn_size"
                :style="'z-index: 998; width: 42px; height: 42px; position: relative; top:' + topPositionAddButton + 'px' +
                                '; left: ' + leftPositionAddButton + 'px;'"
            >
                <i
                    v-if="buttonsLoading['loading_add_button']"
                    class="fa fa-spinner fa-spin"
                ></i>
                <i v-else class="fas fa-plus fa-sm"></i>
            </button>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { app } from "../../application.js";
import editParameterValueComponent from "./../editParameterValue.vue";
import { parse } from "path";
import { MultiLevel } from "@/services/multiLevel.js";

export default {
    name: "mainElements52Component",
    data() {
        return {
            app: app,
            confirmBeforeLeave: true,
            parameters: [],
            mainElementDistribution: "",
            labelOverDropdown: true,
            crossCompartimentosDimensiones: [],
            window: { width: 0, height: 0 },
            buttonsLoading: [],
            multiLevel: app.multiLevelHelper,
        };
    },
    components: { editParameterValueComponent },
    computed: {
        isMobile: function () {
            let a = this.window.width < 580;
            return a;
        },
        isMobile2: function () {
            let a = this.window.width < 750 && this.window.width > 580;
            return a;
        },
        isTablet: function(){
            let a = this.window.width < 900 && this.window.width > 750;
            return a;
        },
        isDesktop: function(){
            let a = this.window.width > 900;
            return a;
        },
        input_width: function () {
            return 170;
        },
        imgSize: function () {
            if (this.isMobile) {
                return 200;
            }
            return 250;
        },
        showDeleteButton: function () {
            return (
                Object.keys(app.currentConfiguration.mainElementParameters)
                    .length > 1
            );
        },
        leftPositionRemoveButton: function () {
            if (this.isDesktop) {return -70;
            }else if (this.isTablet) {return 215;
            }else if (this.isMobile2) {return 215;
            }else if (this.isMobile){return 100;}
        },
        topPositionRemoveButton: function () {
            if (this.isDesktop) {return 200;
            }else if (this.isTablet) {return 455;
            }else if (this.isMobile2) {return 455;
            }else if (this.isMobile){return 695;}
        },
        leftPositionAddButton: function () {
            if (this.isDesktop) {return 0;
            }else if (this.isTablet) {return 30;
            }else if (this.isMobile2) {return 30;
            }else if (this.isMobile){return 20;}
        },
        topPositionAddButton: function () {
            if (this.isDesktop) {return 0;
            }else if (this.isTablet) {return -45;
            }else if (this.isMobile2) {return -45;
            }else if (this.isMobile){return -47;}
        },
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        cleanAllSelectors: async function () {
            console.log("cleanAllSelectors...");

            //loop through mainElementParameters values resetting all selected values in currentConfiguration.mainElementParameters
            let mainparams = this.app.currentConfiguration
                .mainElementParameters;

            Object.values(mainparams).map((mainparam) => {
                Object.values(mainparam).map((item) => {
                    if (item.value.constructor.name == "Array") {
                        item.value = [];
                    } else {
                        item.value = "";
                    }
                });
            });

            this.refreshParameters();
        },
        cleanSpecificSelectors: async function (selectedKey) {

            let selectedElement = this.app.currentConfiguration.mainElementParameters[
                selectedKey
            ];

            if (selectedElement) {
                Object.values(selectedElement).map((elProperty) => {
                    if (elProperty.value.constructor.name =="Array") {
                        elProperty.value = [];
                    } else {
                        elProperty.value = "";
                    }
                });
            }

            this.refreshParameters();
        },
        addElement: async function(key = null) {
            var self = this;
            Vue.set(self.buttonsLoading, key, 1);
            await this.multiLevel.addElement();
            Vue.set(self.buttonsLoading, key, 0);
        },
        refreshParameters: async function () {
            await this.app.asyncProcess(false, false);
        },

        removebandeja: async function (keyBandejaABorrar, key_remove_loading) {
            var self = this;

            Vue.set(this.buttonsLoading, key_remove_loading, 1);

            //------------------------------------------------------------------------------------
            //espera que Vue vacie la cola asincrónica de actualizaciones del DOM para realizar actualizaciones de DOM -> eliminar bandeja
            //------------------------------------------------------------------------------------
            this.$nextTick(async () => {

                delete self.app.currentConfiguration.mainElementParameters[
                    keyBandejaABorrar
                ];

                self.bandejas = self.app.currentConfiguration.mainElementParameters;

                self.renombraBandejas();

                await app.asyncProcess(false, false);

                Vue.set(self.buttonsLoading, key_remove_loading, 0);

            });
            //------------------------------------------------------------------------------------

        },

        renombraBandejas: function () {
            let newKey = 0;
            Object.entries(
                this.app.currentConfiguration.mainElementParameters
            ).forEach(([key, value]) => {
                newKey += 1;
                if (
                    this.app.currentConfiguration.mainElementParameters.hasOwnProperty(
                        key
                    )
                ) {
                    delete this.app.currentConfiguration.mainElementParameters[
                        key
                    ];
                    this.app.currentConfiguration.mainElementParameters[
                        newKey
                    ] = value;
                }
            });
        },
    },
    created() {
        //get window size
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    async beforeMount() {},
};
</script>

<style lang="scss">
</style>
